import { Filters, PaginateRequest, PaginateResponse } from '@/core/model';
import { User } from '@/core/model/User';
import { getPaginate } from '@/core/service/UserService';
import { reactive } from 'vue';

const state = reactive<{ users?: User[] }>({
  users: undefined,
});

const actions = {
  async GetAll(forceRefresh = false) {
    if (!state.users || forceRefresh) {
      const { data } = await getPaginate();
      state.users = data;
      state.users.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
  },

  async GetPaginate(paginate: PaginateRequest, filters?: Filters): Promise<PaginateResponse<User>> {
    await this.GetAll();
    return applyFilters(paginate, filters);
  },
};

function applyFilters({ limit, page }: PaginateRequest, f?: Filters): PaginateResponse<User> {
  if (!state.users) return { data: [], page: 0, recordsTotal: 0 };
  let data = state.users;
  if (f?.name) data = data.filter((d) => d.name.toLowerCase().includes(f.name ?? ''));

  const recordsTotal = data.length;

  const start = (page - 1) * limit;
  const end = start + limit;
  data = data.slice(start, end);

  return { data, page, recordsTotal };
}

const getters = {};

export { state, actions, getters };
